'use client';

import { MotionConfig } from 'framer-motion';
import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import NavigationTracker from '@/components/utilities/navigation-tracker/navigation-tracker';
import { createClientTelemetry } from '@/libraries/monitoring/telemetry-client';

const queryClient = new QueryClient();

const Providers = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    createClientTelemetry();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <MotionConfig reducedMotion="user">
        <NavigationTracker />

        {children}
      </MotionConfig>
    </QueryClientProvider>
  );
};

Providers.displayName = 'Providers';

export default Providers;
